// SPDX-License-Identifier: AGPL-3.0-or-later
// KONVO: how a machine is doing, read live from it for its page on Agents (konvo-agents 0.67.0+;
// machineStats.ts in the bridge). Its history stays on the machine and Konvo keeps none of this.
// Processes are names only: a command line can carry secrets.

import {z} from 'zod';

export const AGENT_MACHINE_STATS_RANGES = ['1h', '6h', '24h', '7d'] as const;
export const AgentMachineStatsRangeSchema = z.enum(AGENT_MACHINE_STATS_RANGES);
export type AgentMachineStatsRange = z.infer<typeof AgentMachineStatsRangeSchema>;

export const AgentMachineStatsArgsSchema = z.object({
	range: AgentMachineStatsRangeSchema,
	lite: z.boolean().optional(),
});

export const AgentMachineStatsSampleSchema = z.object({
	at: z.number(),
	cpu: z.number(),
	load: z.number(),
	mem: z.number(),
	swap: z.number(),
	disk: z.number(),
	temp: z.number().nullable(),
	hot: z.boolean(),
});
export type AgentMachineStatsSample = z.infer<typeof AgentMachineStatsSampleSchema>;

export const AgentMachineStatsSchema = z.object({
	at: z.string(),
	cores: z.number(),
	uptimeSeconds: z.number(),
	cpu: z.number(),
	load: z.number(),
	memUsed: z.number(),
	memTotal: z.number(),
	swapUsed: z.number(),
	swapTotal: z.number(),
	diskUsed: z.number(),
	diskTotal: z.number(),
	temp: z.number().nullable(),
	heat: z
		.object({
			level: z.enum(['normal', 'hot', 'critical']),
			since: z.string().nullable(),
			capsWatts: z.array(z.number()).max(4).nullable(),
			fansRpm: z.number().nullable(),
		})
		.nullable(),
	history: z.array(AgentMachineStatsSampleSchema).max(200),
	processes: z
		.array(z.object({name: z.string().max(80), cpu: z.number(), memory: z.number(), count: z.number()}))
		.max(8),
	work: z.object({ciRunners: z.number(), browsers: z.number()}),
});
export type AgentMachineStats = z.infer<typeof AgentMachineStatsSchema>;
